import React, { Component } from "react";
import moment from "moment";
import Cookies from "universal-cookie";
import axios from "axios";

import {
  Row,
  Col,
  Container,
  Button,
  FormGroup,
  InputGroup,
  FormSelect,
  InputGroupAddon,
  InputGroupText,
} from "shards-react";

class Operations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentAdmin: "",
      loading: false,
      operations: this.props.operations,
      recharge: 5,
    };
  }

  componentDidMount = () => {
    const cookies = new Cookies();
    this.setState({ currentAdmin: cookies.get("userLoggedIn") });
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleSubmit = () => {
    const { href } = window.location;
    const studentId = href.substring(href.lastIndexOf("/") + 1);

    const { currentAdmin, recharge } = this.state;

    let operations = [...this.state.operations];
    operations.push({
      by: {
        username: currentAdmin,
      },
      time: Date(),
      value: recharge,
    });

    this.setState({ loading: true });

    axios
      .post(`${process.env.REACT_APP_API_URL}/admin/students/operate`, null, {
        withCredentials: true,
        params: {
          id: studentId,
          value: recharge,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          this.setState({ operations, loading: false });
        }
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({ loading: false });
      });
  };

  render() {
    const { operations, loading } = this.state;
    const recharges = [5, 10, 15, 20, 25, 30, 50];
    const { isVerified } = this.props;

    return (
      <Container>
        {isVerified ? (
          <div>
            <Row className="justify-content-center mb-2">
              <h2>Les operations</h2>
            </Row>
            <Row className="d-flex justify-content-center">
              <Col md="3" className="form-group">
                <FormGroup>
                  <InputGroup className="mb-3">
                    <FormSelect name="recharge" onChange={this.handleChange}>
                      {recharges.map((recharge, index) => (
                        <option key={index}>{recharge}</option>
                      ))}
                    </FormSelect>
                    <InputGroupAddon type="prepend">
                      <InputGroupText>Dh</InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                </FormGroup>
              </Col>
              <Col md="2" className="form-group">
                <Button
                  type="submit"
                  theme="primary"
                  onClick={this.handleSubmit}
                  disabled={loading}
                >
                  {loading && <i className="fa fa-refresh fa-spin"></i>}
                  {loading && " Attendez s'il vous plaît"}
                  {!loading && "Valider"}
                </Button>
              </Col>
            </Row>
            <hr />
            <Row>
              <table className="table mb-0">
                <thead className="bg-light">
                  <tr>
                    <th scope="col" className="border-0">
                      #
                    </th>
                    <th scope="col" className="border-0">
                      Operation par
                    </th>
                    <th scope="col" className="border-0">
                      date
                    </th>

                    <th scope="col" className="border-0">
                      valeur
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {operations.map((operation, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{operation.by.username}</td>
                      <td>
                        {moment(operation.time).format("D MMMM YYYY, h:mm a")}
                      </td>
                      <td>{operation.value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Row>
          </div>
        ) : (
          <div></div>
        )}
      </Container>
    );
  }
}

export default Operations;
